export const isInIframe = ()=>{
    try {
        return typeof window !== "undefined" && window.self !== window.top;
    } catch (e) {
        return true;
    }
};
